/* eslint-disable import/prefer-default-export */
import { put, call } from 'redux-saga/effects';

import { updateAlertsDisplayed } from '../../../actions';

import { fetchAlertDataRequest } from '../requests';

export function* updateAlertsDisplayService() {
  yield put(updateAlertsDisplayed());
}

export function* fetchAlertDataService(deviceId, data) {
  yield call(fetchAlertDataRequest, deviceId, data);
}
